<template>
	<div style="display: flex">
		<cloud-sidebar :open="open" @change="change" />
		<router-view :className="className" />
	</div>
</template>

<script>
import CloudSidebar from "@/modules/cloud/component/Sidebar"

export default {
	name: "Cloud",
	components: {
		"cloud-sidebar": CloudSidebar
	},
	data() {
		return {
			open: false,
			changeStatus: 0,
			className: "expand"
		}
	},
	methods: {
		change: function () {
			this.open = !this.open
			this.className = this.open ? "collapsed" : "expand"
		}
	}
}
</script>

<style scoped></style>
